// Device ID Manager Class
export default class DeviceIdManager {
  constructor() {
    this.DEVICE_ID_KEY = "device_fingerprint_id";
    this.SESSION_COUNT_KEY = "device_session_count";
    this.DEVICE_INFO_KEY = "device_info";
  }

  // Generate or retrieve device ID
  async getDeviceId() {
    let deviceId = this.getStoredDeviceId();

    if (!deviceId) {
      deviceId = this.generateNewDeviceId();
      await this.storeDeviceId(deviceId);
    }

    this.incrementSessionCount();
    return deviceId;
  }

  generateNewDeviceId() {
    return "device_" + this.generateGUID();
  }

  generateGUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  getStoredDeviceId() {
    try {
      return localStorage.getItem(this.DEVICE_ID_KEY);
    } catch (e) {
      return null; // LocalStorage not available (incognito, etc.)
    }
  }

  async storeDeviceId(deviceId) {
    try {
      localStorage.setItem(this.DEVICE_ID_KEY, deviceId);

      // Store additional device info
      const deviceInfo = {
        createdAt: new Date().toISOString(),
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        screenResolution: screen.width + "x" + screen.height,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      localStorage.setItem(this.DEVICE_INFO_KEY, JSON.stringify(deviceInfo));
      localStorage.setItem(this.SESSION_COUNT_KEY, "1");

      return true;
    } catch (e) {
      return false; // Storage failed
    }
  }

  incrementSessionCount() {
    try {
      const count =
        parseInt(localStorage.getItem(this.SESSION_COUNT_KEY) || "0") + 1;
      localStorage.setItem(this.SESSION_COUNT_KEY, count.toString());
      return count;
    } catch (e) {
      return 0;
    }
  }

  getSessionCount() {
    try {
      return parseInt(localStorage.getItem(this.SESSION_COUNT_KEY) || "0");
    } catch (e) {
      return 0;
    }
  }

  getDeviceInfo() {
    try {
      const info = localStorage.getItem(this.DEVICE_INFO_KEY);
      return info ? JSON.parse(info) : null;
    } catch (e) {
      return null;
    }
  }

  resetDevice() {
    try {
      localStorage.removeItem(this.DEVICE_ID_KEY);
      localStorage.removeItem(this.DEVICE_INFO_KEY);
      localStorage.removeItem(this.SESSION_COUNT_KEY);
      return true;
    } catch (e) {
      return false;
    }
  }

  async isIncognitoMode() {
    if ("storage" in navigator && "estimate" in navigator.storage) {
      const estimate = await navigator.storage.estimate();
      return estimate.quota < 120000000;
    }
    return !this.getStoredDeviceId() && this.canAccessLocalStorage();
  }

  canAccessLocalStorage() {
    try {
      localStorage.setItem("test", "test");
      localStorage.removeItem("test");
      return true;
    } catch (e) {
      return false;
    }
  }
}
